import { Component, DestroyRef, ElementRef, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { SharedService } from '../../shared/services/shared.service';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { SchoolService } from '../school/school.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-onepage',
  templateUrl: './onepage.component.html',
  styleUrl: './onepage.component.scss'
})
export class OnepageComponent implements OnInit {
  title: string = '';
  
logout() {

  this.closePopupWindow();
  this.sharedService.logout();
}
  @Input() showClose = false;


  isLoading: boolean = true;
  popupUrl: string | null = null;
  isPopup: boolean = false;
  routeTitle: string = '';
  userName: string | null = ''
  todayTime: string | null = ''

  clientReference: string | null = null;
  
  AccountOrSchoolLogo: string = '';
  AccountLogoShape: string  = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private schoolService: SchoolService,
    private toastrService: ToastrService
  ) { }
  
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.isLoading = true;
    this.routeTitle = this.getRouteTitle();
    this.title = this.routeTitle;
    this.sharedService.popUpTitle
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(title => {
        this.title = title
      });

    this.sharedService.popUpLoading
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });
    
    const decodedToken = this.sharedService.getLoginToken()
    if (decodedToken == null) {
      this.userName = null;
      return
    };
    this.userName = `${decodedToken.unique_name} (${decodedToken.email})`;
    this.todayTime = new Date().toLocaleDateString();

    this.popupUrl = this.router.url;
    // const isPopupRoute = this.route.snapshot.data['isPopup'] === true;
    // this.isPopup = isPopupRoute;
    // Automatically detects if component is rendering in the 'popup' outlet

    if (this.route.outlet === 'popup' || this.router.url.includes('popup:')) {
      this.isPopup = true;

    }

    this.showClose = this.isPopup;

    this.clientReference =
      sessionStorage.getItem('client_reference');

    this.setClientLogo(this.clientReference);
  }

  getRouteTitle(): string {
    let route = this.route;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.title ?? '';
  }

  setClientLogo(clientReference: string | null) {
    var clientRefType = 'CA'; //CA
    clientReference = clientReference || null;

    if (!clientReference) {
      clientRefType = sessionStorage.getItem("orgType") ?? "";
      clientReference = sessionStorage.getItem("orgRef");
    }

    if (clientReference == null || clientReference == '') {
      this.AccountOrSchoolLogo = '';
      this.AccountLogoShape = '';
    }
    else {
      this.schoolService.getLogo(clientRefType, clientReference)
        .subscribe((response: any) => {
          var accountLogo = response?.dsh_logo_url;
          var logoShape = response?.dsh_logo_shape;
          this.AccountOrSchoolLogo = accountLogo;
          this.AccountLogoShape = logoShape;
        });
    }
  }

  @ViewChild('popup_window_body')
  popupWindowBody!: ElementRef<HTMLDivElement>;

  // printPopupWindow(){
  //   this.sharedService.printPopupWindow();
  // }
  openPopupFullScreen(){
    this.popupWindowBody.nativeElement.requestFullscreen();
  }

  openPopupWindow() {
    const url = this.popupUrl!;
    const match = url.match(/\((.*?)\)/);

    if (match) {
      const path = match[1].replace('popup:', '');
      window.open(`${window.location.origin}/${path}`, '_blank');
      this.closePopupWindow();
    }

  }
  closePopupWindow() {
    this.sharedService.closePopupWindow(true);
  }


}
